import { types, actions } from './requests'
export const GETRECENTMACHINELIST_TYPES = {
    ...types('GETRECENTMACHINELIST'),
}
export const GETRECENTMACHINELIST_ACTIONS = {
    ...actions('GETRECENTMACHINELIST'),
}
